import httpApiApplication from '@/app/http/httpApiApplication';

import { type IdValue } from '../../TaxStatement/FormVersion/types';
import {
  type PaymentDeclaration,
  type PaymentDeclarationContent,
  type PaymentSummary,
  type PaymentTaxpayerStats
} from '../models/Payment';

export const BaseUrPayment = '/payments';
export const BaseUrPaymentDeclaration = '/payments/declaration';

export const paymentService = {
  getTaxpayerStats: async (): Promise<PaymentTaxpayerStats> => {
    const response = await httpApiApplication.get<PaymentTaxpayerStats>('/payments/stats');

    return response;
  },
  createPaymentDeclaration: async (payment: PaymentDeclarationContent): Promise<IdValue> => {
    return httpApiApplication.post(BaseUrPaymentDeclaration, payment);
  },
  getPaymentDeclaration: async (id: string): Promise<PaymentDeclaration> => {
    return httpApiApplication.get(BaseUrPaymentDeclaration + '/' + id);
  },
  getPayment: async (id: string): Promise<PaymentSummary> => {
    return httpApiApplication.get('/payments' + '/' + id);
  }
};
